import { memo } from "react";
import { EXTERNAL_PAYMENT_METHODS, PAYMENT_METHODS } from "app/constants";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";

export const PaymentButtonLabel = ({ paymentType, cartAmount, isOperatorMode }) => {
	let paymentButtonLabel = <FormattedMessage id="payment.submit" />;
	const isNothingToPay = cartAmount === 0;

	if (isOperatorMode) {
		paymentButtonLabel = <FormattedMessage id="payment.operator.submit.label" />;
	} else if (isNothingToPay) {
		paymentButtonLabel = <FormattedMessage id="payment.submit.nothing.to.pay" />;
	} else if (EXTERNAL_PAYMENT_METHODS.includes(paymentType)) {
		paymentButtonLabel = (
			<FormattedMessage
				id="payment.external.submit.continue"
				values={{
					paymentPartner: <FormattedMessage id={`payment.method.${paymentType}`} />,
				}}
			/>
		);
	} else {
		switch (paymentType) {
			case PAYMENT_METHODS.SWISS_BILLING:
				paymentButtonLabel = <FormattedMessage id="payment.submit.only.validate" />;
				break;
			case PAYMENT_METHODS.CHECKOUT:
				paymentButtonLabel = <FormattedMessage id="payment.submit.continue.to.payment" />;
				break;
			default:
				break;
		}
	}

	return paymentButtonLabel;
};

PaymentButtonLabel.prototype = {
	paymentType: PropTypes.string,
	cartAmount: PropTypes.number,
};

export default memo(PaymentButtonLabel);
